import { FC } from 'react';
import { Button } from 'antd';

interface DeveloperCredentialPreviewProps {
    value: string;
}

/**
 * Displays the persisted, masked form of a developer credential without
 * implying that the underlying secret can be recovered after creation.
 */
const DeveloperCredentialPreview: FC<DeveloperCredentialPreviewProps> = ({ value }) => (
    <Button
        aria-label='Masked credential'
        size='small'
        style={{ cursor: 'default', flex: '1 1 auto', minWidth: 0, pointerEvents: 'none', textAlign: 'left' }}
    >
        <code style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {value}
        </code>
    </Button>
);

export default DeveloperCredentialPreview;
